/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Stat_StudentsInputs */

const en_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Students Coached`)
};

const es_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estudiantes con Mark`)
};

const de_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betreute Golfschüler`)
};

const zh_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指导学生`)
};

const ar_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طلاب درّبهم`)
};

const fr_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Élèves accompagnés`)
};

const vi_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Học viên đã huấn luyện`)
};

const sw_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wanafunzi Waliofundishwa`)
};

const th_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นักเรียนที่ฝึกสอน`)
};

const bs_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treniranih učenika`)
};

const ja_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指導した生徒`)
};

const ko_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지도한 학생`)
};

const pt_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alunos treinados`)
};

const it_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allievi allenati`)
};

const sv_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tränade elever`)
};

const nl_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leerlingen gecoacht`)
};

const da_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trænede elever`)
};

const nb_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trente elever`)
};

const fi_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valmennettua oppilasta`)
};

const pl_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyszkoleni uczniowie`)
};

const ru_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подготовленных учеников`)
};

const tr_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çalıştırdığı Öğrenci`)
};

const hi_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रशिक्षित छात्र`)
};

const id_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siswa Dilatih`)
};

const ms_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajar Dibimbing`)
};

const cs_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trénovaných žáků`)
};

const el_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μαθητές που έχει προπονήσει`)
};

const he_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תלמידים שאומנו`)
};

const af_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studente afgerig`)
};

const hu_home_stat_students = /** @type {(inputs: Home_Stat_StudentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oktatott tanítvány`)
};

/**
* | output |
* | --- |
* | "Students Coached" |
*
* @param {Home_Stat_StudentsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_stat_students = /** @type {((inputs?: Home_Stat_StudentsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Stat_StudentsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_stat_students(inputs)
	if (locale === "de") return de_home_stat_students(inputs)
	if (locale === "zh") return zh_home_stat_students(inputs)
	if (locale === "ar") return ar_home_stat_students(inputs)
	if (locale === "fr") return fr_home_stat_students(inputs)
	if (locale === "vi") return vi_home_stat_students(inputs)
	if (locale === "sw") return sw_home_stat_students(inputs)
	if (locale === "th") return th_home_stat_students(inputs)
	if (locale === "bs") return bs_home_stat_students(inputs)
	if (locale === "ja") return ja_home_stat_students(inputs)
	if (locale === "ko") return ko_home_stat_students(inputs)
	if (locale === "pt") return pt_home_stat_students(inputs)
	if (locale === "it") return it_home_stat_students(inputs)
	if (locale === "sv") return sv_home_stat_students(inputs)
	if (locale === "nl") return nl_home_stat_students(inputs)
	if (locale === "da") return da_home_stat_students(inputs)
	if (locale === "nb") return nb_home_stat_students(inputs)
	if (locale === "fi") return fi_home_stat_students(inputs)
	if (locale === "pl") return pl_home_stat_students(inputs)
	if (locale === "ru") return ru_home_stat_students(inputs)
	if (locale === "tr") return tr_home_stat_students(inputs)
	if (locale === "hi") return hi_home_stat_students(inputs)
	if (locale === "id") return id_home_stat_students(inputs)
	if (locale === "ms") return ms_home_stat_students(inputs)
	if (locale === "cs") return cs_home_stat_students(inputs)
	if (locale === "el") return el_home_stat_students(inputs)
	if (locale === "he") return he_home_stat_students(inputs)
	if (locale === "af") return af_home_stat_students(inputs)
	if (locale === "hu") return hu_home_stat_students(inputs)
	return en_home_stat_students(inputs)
});